import React, { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { TagApi } from "../../services/Api/Organization/types";
import { api } from "../../services/Api/api";

interface Props {
	form: UseFormReturn<any>;
	tags?: TagApi[];
}

export const TagsFormInput: FC<Props> = ({ form }) => {
	const { t } = useTranslation();
	const {
		getValues,
		setValue,
		control,
		formState: { errors },
		watch,
	} = form;

	const onCreateTag = (val: string) => {
		setValue(
			"tags",
			[
				...(getValues()?.tags || []),
				{
					id: val,
					name: val,
				},
			],
			{ shouldDirty: true }
		);
	};

	const onChangeTags = (values: TagApi[]) => {
		setValue("tags", values);
	};

	const onSearchTags = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		const res = await api.organization().getTagSearchSelect(search, params, {
			cancelToken: options?.token,
		});

		return res.map((x) => ({
			...x,
			name: x.label,
		}));
	};

	const onGetDefaultTagsValue = (tags: TagApi[]) => {
		return tags?.map((tag) => ({
			id: tag.id,
			name: tag.name,
		}));
	};

	return (
		<FormSelectGroup
			label={t("common.word.tags")}
			isMulti
			name="tags"
			errors={errors}
			defaultValue={onGetDefaultTagsValue(watch("tags"))}
			getOptionValue={(opt) => opt.id}
			getOptionLabel={(opt) => opt.name}
			loadOptions={onSearchTags}
			control={control}
			data-testid="tags"
			onChange={(value, valueObj) => onChangeTags(valueObj)}
			onCreateOption={onCreateTag}
		/>
	);
};

export const mapTagsToAcceptableByBackendFormat = (tags: TagApi[]) => tags.map((tag) => ({ name: tag.name } as TagApi));
